import RawApiClient, {
  throwNon200ResponseTransformer,
  parseBodyAsJsonResponseTransformer,
} from "./RawApiClient";
import getEnvironmentRequestTransformer from "./getEnvironmentRequestTransformer";
const rawAapi1Client = new RawApiClient({
  requestTransformers: [getEnvironmentRequestTransformer("aapi1")],
  responseTransformers: [
    throwNon200ResponseTransformer,
    parseBodyAsJsonResponseTransformer,
  ],
});
export default rawAapi1Client;
